import React, { useEffect, useState } from "react";
import { auth } from "../firebase";
import { applyActionCode, checkActionCode } from "firebase/auth";
import "./EmailChange.css"; // Reuse styling from the email change CSS

const RevertMFA = ({ actionCode }) => {
  const [secondFactorInfo, setSecondFactorInfo] = useState(null);
  const [statusMessage, setStatusMessage] = useState("Verifying your second factor removal request...");
  const [isReverted, setIsReverted] = useState(false);
  const APP_NAME = "Guardian Mobile"; // Replace with your app's name

  useEffect(() => {
    const verifyRevert = async () => {
      try {
        const info = await checkActionCode(auth, actionCode);
        // Firebase should return details for the second factor that was added.
        // Here we assume that the info.data contains a field named secondFactor.
        const factorDetail = info.data.multiFactorInfo.phoneNumber;
        setSecondFactorInfo(factorDetail);
        setStatusMessage(`Your account in ${APP_NAME} is currently set up with ${factorDetail} as a second factor authentication method.`);
      } catch (err) {
        setStatusMessage(`Error verifying second factor removal: ${err.message}`);
      }
    };
    verifyRevert();
  }, [actionCode]);

  const handleRevert = async () => {
    try {
      await applyActionCode(auth, actionCode);
      setStatusMessage(`Your second factor has been successfully removed!`);
      setIsReverted(true);
    } catch (err) {
      setStatusMessage(`Error reverting second factor addition: ${err.message}`);
    }
  };

  return (
    <div className="email-change-container">
      <div className="email-change-card">
        <div className="logo-container">
          <img src="/guardianLogo.png" alt="Logo" className="logo" />
        </div>
        <h2 className="email-change-title">Revert Second Factor Addition</h2>
        <p className="email-change-instructions">{statusMessage}</p>
        {!isReverted && secondFactorInfo && (
          <button onClick={handleRevert} className="email-change-button">
            Remove Second Factor
          </button>
        )}
        {isReverted && (
          <p className="status-message">
            Your account is no longer protected by the second factor.
          </p>
        )}
      </div>
    </div>
  );
};

export default RevertMFA;
